/**
 * `ContentV2.biddingStrategy.type` is a plain String in the schema, so these are the
 * harmonized values the backend stores, not a generated enum.
 */
const ROAS_BIDDING_STRATEGIES = ['Target ROAS', 'Maximize conversion value'];

export function isRoasBiddingStrategy(biddingStrategyType?: string | null): boolean {
  return !!biddingStrategyType && ROAS_BIDDING_STRATEGIES.includes(biddingStrategyType);
}
